import React,{ useState }  from 'react';
import axios from 'axios'
import { List, Box, Typography, Input, Button, 
TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal,Pagination } from '@mui/material'
import { useRedirect } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import legolasApi from '../../api/legolas'
import DeleteIcon from '@mui/icons-material/Delete'
import ChannelDropDown from '../common/ChannelDropDown';

const PAGE_SIZE = 20;

export default function GiftList() {
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: '#2b3f7a',
          color: theme.palette.common.white,
          padding: globalStyles.common.infoTablesPadding,
          borderRight: '2px solid #fff',
          whiteSpace: 'nowrap',
          borderRadius: '0px !important'
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
          padding: globalStyles.common.infoTablesPadding,
          borderRadius: '0px !important'
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

  const [totalCount, setTotalcount] = useState(0)
  const [listData, setListData] = useState([])
  const [searchString, setSearchstring] = useState('')
  const [deleteModal, setdeleteModal] = useState(false);
  const [selectedGiftId, setSelectedGiftId] = useState(null);
  const selectedHeaders = [
    { id: '_id', label: 'ID' },
    { id: 'name', label: 'Gift Name' },
    { id: 'giftCode', label: 'Gift Code' },
    { id: 'active', label: 'Active' },
    { id: 'fromDate', label: 'Start From' },
    { id: 'toDate', label: 'End To' },
    { id: 'channelName', label: 'Channel' },
  ];
  const [currentPage, setCurrentPage] = useState(1)
  const [channelData, setChannelData] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const [loading,setLoading] = useState(false);
  const giftRequestId = React.useRef(0);
  const redirect = useRedirect()
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const getChannel=()=>{
    axios.get(`${legolasApi.url}/admin/channel/list`)
    .then((res) => {
      console.log('order res: ', res.data.data);
      //setChannelData(res.data.data);
      const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
    })
    .catch((error) => console.log('Error in getting orders: ', error));
  }
const buildGiftQueryParams = ({ search, filter, offset = 0, limit = PAGE_SIZE, userChannels }) => {
  const params = new URLSearchParams();

  if (search) params.append('search', search);
  if (filter) params.append('filter', filter);
  if (offset !== undefined) params.append('offset', offset);
  if (limit !== undefined) params.append('limit', limit);
  if (userChannels?.length > 0) params.append('channels', userChannels.join(','));

  return params.toString();
};

  const getAllGift = ({ page = currentPage, search = searchString, filter = filterValue } = {}) =>{
    const requestId = ++giftRequestId.current;
    setLoading(true);
    const query = buildGiftQueryParams({
      search: search.trim(),
      filter,
      offset: (page - 1) * PAGE_SIZE,
      limit: PAGE_SIZE,
      userChannels
    });

    axios.get(`${legolasApi.url}/admin/gift/list?${query}`).then((res) => {
      if (requestId !== giftRequestId.current) return;
      const data = res.data.data.data ,count = res.data.data.count
      setListData(data)
      setTotalcount(count)
      setCurrentPage(page)
    }).catch((error) => console.log('Error in getting gifts: ', error))
      .finally(() => {
        if (requestId === giftRequestId.current) setLoading(false);
      });
  }

  React.useEffect(() => {
    getChannel();
    getAllGift({ page: 1, search: '', filter: '' });
  }, [])

  const handleFilter = (field, value) => { 
    let newFilterValue = '';
    if (field === 'channel') {
        newFilterValue = value !== null ? value : '';
    }
    setFilterValue(newFilterValue);
    getAllGift({ page: 1, search: searchString, filter: newFilterValue });
}

  const handleClose = () => {
    setdeleteModal(false)
  };

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }


  const handlePagination = (event, value) => {
    getAllGift({ page: value, search: searchString, filter: filterValue });
  }

 
  const handleSearch = () => {
    getAllGift({ page: 1, search: searchString, filter: filterValue });
  }

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchstring(value);

    // Native search input emits an empty value when its clear (x) icon is
    // clicked. Reload the complete list instead of retaining search results.
    if (value === '') {
      getAllGift({ page: 1, search: '', filter: filterValue });
    }
  }

  const handleEditClick = (id) => {
    const redirectUrl = `/edit-gift/${id}`
    redirect(redirectUrl)
  }
  const createNewRule = () => {
    const redirectUrl = `/add-gift`
    redirect(redirectUrl)
  }

  const handleDeleteClick =(id) =>{
    const giftId = id;
    console.log("gift",id)
    const fetchAll = {
     "deleted":true,
     "active":false
    }
    axios.post(`${legolasApi.url}/admin/gift/delete/${giftId}`,fetchAll).then((res)=>{
      console.log("order delete",res)
      setdeleteModal(false)
      getAllGift();
    }).catch((error) => console.log('Error in deleting gift: ', error))
  }

  return (
    <React.Fragment>
    <List actions={null}>
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
          <Typography variant='h4'>Gifts</Typography>
          <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
            {totalCount} record(s) found
          </Typography>
        </Box>
      </Box>
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ 
            width: '100%', 
            display: 'flex', 
            margin: '0px 30px',
            '& .MuiInput-input': {
              width: '300px !important',
              padding: '5px 10px !important'
            },
            '& .MuiSvgIcon-root': {
              paddingRight: '10px'
            } 
          }}>
            <Input 
              type='search' 
              sx={{ border: '1px solid #2b3f7a', borderRadius: '20px',height:'40px', marginTop:'20px',marginRight:'5%' }} 
              endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
              placeholder='Search by Gift ID'
              onChange={handleSearchChange}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
            />
            { userChannels.length > 1 && ( <ChannelDropDown channelData={channelData} handleChannelFilter={handleFilter} /> )}
            
            <Box sx={{ 
              width: '50vw', 
              justifyContent: 'end', 
              textAlign: 'end',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important' 
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              }
              }}>
                  <Box sx={{ width: '50%', alignItems: 'center', margin: '20px',marginLeft:"45%" }}>
              <Button variant="contained" sx={globalStyles.createButton} onClick={() => createNewRule()}>
                Add New Gift
              </Button>
            </Box>
            </Box>
          </Box>
      </Box>
      <Box>
      <Modal
            open={deleteModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={globalStyles.modalContainer}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Are you sure you want to delete this Gift?
              </Typography>
              <Box sx={{
                display: 'flex', justifyContent: 'end', marginTop: '20px',
                '& .MuiButton-root': {
                  color: globalStyles.colors.backgroundPrimary,
                  textTransform: 'capitalize'
                }
              }}>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={() => handleDeleteClick(selectedGiftId)} >OK</Button>
              </Box>
            </Box>
          </Modal>
        <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
        <Table aria-label="simple table">
            <TableHead sx={{ 
              backgroundColor: globalStyles.colors.backgroundPrimary, 
              height: '40px !important',
              borderRadius: '0 !important',
              '& .MuiTableCell-root': {
                color: '#fff !important',
                padding: '10px !important',
                borderRight: '2px solid #fff !important',
                borderRadius: '0 !important'
              }
            }}>
              <TableRow>
                {selectedHeaders.map((header) => [
                  <StyledTableCell align='center'>{header.label}</StyledTableCell>
                ])}
                <StyledTableCell align='center'>Action</StyledTableCell>
                <StyledTableCell align='center'>Delete</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                {listData.map((gift,key) => {
                 
                  return (
                    <StyledTableRow id={key} key={gift._id}>
                      {selectedHeaders.map((header) => {
                        if (header.id === 'fromDate' || header.id === 'toDate') {
                          return (
                            <StyledTableCell align='center'>{formatDateAndTime(new Date(gift.giftValid[header.id]))}</StyledTableCell>
                          )
                        } else if(header.id === 'active') {
                          return (
                            <StyledTableCell align='center'>
                              {gift[header.id]?'true':'false'}
                            </StyledTableCell>
                          )
                        }
                        else {
                          return (
                            <StyledTableCell align='center'>
                              {gift[header.id]}
                            </StyledTableCell>
                          )
                        }
                      })}
                      <StyledTableCell align='center'>
                        <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEditClick(gift._id)}/>
                      </StyledTableCell>
                      <StyledTableCell align='center'>
                        <DeleteIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => {setdeleteModal(true);setSelectedGiftId(gift._id)}} />
                 
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                  
                
                })}
            </TableBody>
          </Table>
    
        </TableContainer>
      </Box>
      <Box sx={{ justifyContent: 'center' }}>
            <Pagination disabled={loading} count={Math.ceil(totalCount / PAGE_SIZE)} page={currentPage} onChange={handlePagination} />
          </Box>
    </List>
  </React.Fragment>
  )
}
